import React from 'react';
import { Heart } from '@finect/tabular-icons/heart';
import { LikeContainer, HeartAction } from './partials';
export var LikeAction = function LikeAction(_ref) {
  var _onClick = _ref.onClick,
    active = _ref.active,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size;
  return React.createElement(LikeContainer, null, React.createElement(HeartAction, {
    title: "A\xF1adir a favoritos",
    onClick: function onClick() {
      _onClick();
    },
    active: active
  }, React.createElement(Heart, {
    size: "".concat(size, "px")
  })));
};